module.exports = __webpack_public_path__ + "files/fffbe816e378a22a0e64991f4cdaf2d2.png";